module.exports = __webpack_public_path__ + "static/media/burrito_03_full.b31b04e5.png";